
import { useContext, useEffect, useRef, useState} from 'react';
import './style/productPage.css';
import { AppContext } from '../../../contextApi/ContextApi';
import { ClientContext } from '../../../contextApi/ClientContext';
import NotFound404 from '../../NotFound404';

export default function ProductPage({website, isDashboard}) {
    const { accent_color, primary_color, secondary_color, fetchImage, connected, cookiesApprooved, setToastMessage, messagesOptions } = useContext(AppContext);
    const {currentProduct, increaseAmount, isUpdatingCart} = useContext(ClientContext);
    const [isHoverBtn, setIsHoverBtn] = useState(false);
    const [hasAStock, setHasAStock] = useState(currentProduct?.hasAmount);
    const [hasInStock, setHasInStock] = useState(currentProduct?.amount>0);


    const [price] = useState(()=>{
        const p = (currentProduct.price/100) * (100 - currentProduct.disValue);
        return p ? `${Number(p.toFixed(2)).toString()}` : null}
        
    );
    const [productImage, setProductImage] = useState(null);
    const [companyImage, setCompanyImage] = useState(null);
    const compRef = useRef(null);
    
    useEffect(()=>{
        setHasAStock(currentProduct?.hasAmount);
        setHasInStock(currentProduct?.amount>0);
        fetchImage(website, currentProduct?.imgURL, setProductImage);
        fetchImage(website, currentProduct?.categoryImgURL, setCompanyImage);
        if(!compRef) return;
        if(isDashboard){
            compRef.current.scrollIntoView({
                behavior:"smooth"
            })
        }
    },[])
    
    if(!cookiesApprooved){return <NotFound404/>}
    return (
        <div className='productPage_component' ref={compRef}>
            <h1 dir='rtl' style={{fontSize:"45px", color:accent_color, textShadow:`2px 2px 3px ${primary_color}`}}>{currentProduct?.name.toUpperCase()}</h1>
            <div className={isDashboard ? "productPage_container_dashboard" :"productPage_container"} style={{backgroundColor:primary_color, color:accent_color, border:`0.5px solid ${accent_color}`}}>
                <div dir='rtl' className="productPage_rightDetails" style={{borderLeft:`1px solid ${accent_color}`}}>
                    <div className='productPage_rightDetails_top'>
                        <div className='productPage_image_div'>
                            <img style={{backgroundColor:secondary_color}} className={isDashboard ? "productPage_image_dashboard" : 'productPage_image'} src={productImage} alt={currentProduct?.name}/>
                            {hasAStock&&!hasInStock && <div className='productPage_image_outOfStock'>המלאי אזל</div>}
                        </div>
                        <h2>{currentProduct?.name}</h2>
                        <h2>{price !== null ? `${price}₪` : "לא צויין מחיר"} <span style={{opacity:0.7, textDecoration:"line-through", marginRight:"10px"}}>{currentProduct.hasDiscount ? `${currentProduct?.price}₪` : null}</span></h2>
                        {connected && (hasAStock&&hasInStock || !hasAStock) && <button disabled={isUpdatingCart} onMouseEnter={()=>{setIsHoverBtn(true)}} onMouseLeave={()=>{setIsHoverBtn(false)}} className={isDashboard ? "productPage_addBtn_dashboard" : 'productPage_addBtn'} style={{backgroundColor:isHoverBtn ? accent_color : secondary_color, color:isHoverBtn ? secondary_color : accent_color}} onClick={()=>{connected&&!isDashboard ? increaseAmount(website, currentProduct, setToastMessage, messagesOptions, true) : isDashboard ? alert("לחצן זה יוסיף את המוצר לעגלה בתנאי שהלקוח רשום כמנוי") : alert("עליך להיות מחובר על מנת לבצע רכישה")}}>{isUpdatingCart ? null : <span>🛒</span>}{isUpdatingCart ? "המתן.." : "הוסף לעגלה"}</button>}
                    </div>
                    <div className='productPage_rightDetails_bottom'></div>
                </div>
                <div dir='rtl' className="productPage_leftDetails">
                    <div className="productPage_leftDetails_topSection">
                        <div className="productPage_logoDiv">
                            <img className='productPage_logoImage' src={companyImage} alt={currentProduct?.category} />
                        </div>
                    </div>
                    <div className="productPage_desc">
                        <p>{currentProduct?.desc}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
